









































































import axios, { AxiosError } from 'axios';
import firebase from 'firebase/app';
import { Component, Vue, Watch } from 'vue-property-decorator';

import Loading from '@/components/common/Loading.vue';
import FeedbackDialog from '@/components/FeedbackDialog.vue';
import OwnFileListDialog from '@/components/OwnFileListDialog.vue';
import UserInfoDialog from '@/components/UserInfoDialog.vue';
import { GIT_HASH } from '@/constants';
import router from '@/router';
import appAuth from '@/store/modules/AppAuth';
import appInfo from '@/store/modules/AppInfoModule';
import loginUser from '@/store/modules/LoginUserModule';
import LoginPage from '@/views/LoginPage.vue';

@Component({
  components: {
    UserInfoDialog,
    FeedbackDialog,
    LoginPage,
    Loading,
    OwnFileListDialog,
  },
})
export default class App extends Vue {
  private loginLoading = true;
  private gitHash = GIT_HASH;
  private userInfoDialog = false;
  private feedbackDialog = false;
  private ownerFileDialog = false;

  private get envName(): string | null {
    return appInfo.envName;
  }

  private get version(): string | null {
    return appInfo.version;
  }

  private get firebaseUser() {
    return appAuth.loggedInUser;
  }

  private get showLoginPage(): boolean {
    return !this.isLogin || (this.succeedSignIn != null && !this.succeedSignIn);
  }

  private get isLogin(): boolean {
    return loginUser.loginUser != null && appAuth.isLoggedIn;
  }

  private succeedSignIn(): boolean | null {
    return appAuth.succeedSignIn;
  }

  /**
   * firebase側だけ認証完了しているか
   */
  private get isLoginOnlyFirebase(): boolean {
    return loginUser.loginUser == null && appAuth.isLoggedIn;
  }

  private get loggedInUserEmail(): string | null {
    return loginUser.loginUser?.userAccount ?? null;
  }

  @Watch('firebaseUser')
  private async firebaseUserChanged(
    newVal: firebase.User | null,
    oldVal: firebase.User | null
  ) {
    if (newVal != null && oldVal == null) {
      // サーバー側の認証ができていればユーザー情報を取得できる
      await loginUser.getLoginUser();

      if (loginUser.loginUser == null) {
        // firebaseは認証済みだが、サーバー側の認証ができていない時
        this.loginLoading = true;
        try {
          if (await this.login(newVal)) {
            // サーバー側の認証が完了したのでユーザ情報を取得
            await loginUser.getLoginUser();
          }
        } finally {
          this.loginLoading = false;
        }
      }
    }
  }

  private async created() {
    this.loginLoading = true;
    const res = await axios.get('/command/info').catch((error: AxiosError) => {
      console.error(error);
      return null;
    });
    if (res != null) {
      appInfo.setAppInfo(res.data);
    }

    // ログイン状態の監視を開始
    appAuth.startWatchingAuthState();
    this.loginLoading = false;

    if (this.$route.query.feedback) {
      this.feedbackDialog = true;
      const query = { ...this.$route.query };
      delete query.feedback;
      this.$router.push({ query });
    }

    if (this.$route.query.error) {
      this.$router.push({ name: 'error' });
    }
  }

  private async login(user: firebase.User): Promise<boolean> {
    const idToken = await user.getIdToken();
    const res = await axios
      .post('/login', {
        idToken: idToken,
      })
      .catch((error: AxiosError) => {
        console.error(error);
        return null;
      });
    return res != null;
  }

  private async setUserInfo() {
    router.push({ name: 'user' });
  }

  private async logout() {
    // server側でのログアウト
    const res = await axios.post('/logout').catch((error: AxiosError) => {
      console.error(error);
      return null;
    });
    if (!res) {
      return;
    }
    // front側でのログアウト(ログイン情報をstoreから削除)
    await appAuth.logout();
    // 認証済みでないと取得できない情報をvuexに保存している可能性があるので更新させる
    location.reload();
  }
}
